import _defineProperty from "/var/lib/jenkins/workspace/yesep-ui/node_modules/@babel/runtime-corejs2/helpers/esm/defineProperty.js";
//
//
//
//
//
import echarts from 'echarts';
import 'echarts/lib/chart/gauge';
import 'echarts/lib/component/tooltip';
import 'echarts/lib/component/title';
import { queryJobOrderAnalysis } from '@/api/api';
export default {
  props: {
    width: {
      type: String,
      default: '450px'
    },
    height: {
      type: String,
      default: '280px'
    },
    top: {
      type: String,
      default: '30px'
    },
    position: {
      type: String,
      default: 'absolute'
    },
    left: {
      type: String,
      default: '0px'
    },
    marginLeft: {
      type: String,
      default: '0px'
    },
    type: {},
    id: {},
    queryType: {}
  },
  data: function data() {
    return {
      chart: 'chart10'
    };
  },
  mounted: function mounted() {
    this.querySewageQuotaList();
  },
  methods: {
    initBarChart: function initBarChart(data) {
      var option = _defineProperty({
        tooltip: {
          trigger: 'axis',
          axisPointer: {
            // 坐标轴指示器，坐标轴触发有效
            type: 'shadow' // 默认为直线，可选为：'line' | 'shadow'

          }
        },
        legend: {
          data: data.legendData,
          top: '5%',
          textStyle: {
            color: 'rgba(55,255,249,1)'
          }
        },
        grid: {
          left: '3%',
          right: '4%',
          bottom: '3%',
          containLabel: true
        },
        xAxis: [{
          type: 'category',
          data: data.xData,
          splitLine: {
            show: false
          },
          axisLine: {
            lineStyle: {
              color: 'rgba(55,255,249,1)'
            }
          },
          axisLabel: {
            color: 'rgba(55,255,249,1)'
          }
        }],
        yAxis: [{
          type: 'value',
          splitLine: {
            show: false
          },
          axisLine: {
            lineStyle: {
              color: 'rgba(55,255,249,1)'
            }
          }
        }],
        series: data.seriesData
      }, "tooltip", {
        show: true
      });

      var chart = this.$refs[this.chart];
      var myChart = this.$echarts.init(chart);
      myChart.setOption(option);
      window.addEventListener('resize', function () {
        myChart.resize();
      }, false);
    },
    // 趋势数据
    querySewageQuotaList: function querySewageQuotaList() {
      var data = {
        xData: ['2023-8-8', '2023-8-9', '2023-8-10', '2023-8-11', '2023-8-12', '2023-8-13', '2023-8-14'],
        seriesData: [],
        legendData: ['一般任务', '较大任务', '重大任务']
      };
      data.seriesData = [{
        name: '一般任务',
        type: 'bar',
        barWidth: 20,
        itemStyle: {
          barBorderRadius: 20,
          color: new echarts.graphic.LinearGradient(0, 0, 0, 1, [{
            offset: 0,
            color: "rgba(55,255,249,1)"
          }, {
            offset: 1,
            color: "rgba(0,222,215,0.2)"
          }])
        },
        data: [6, 5, 6, 9, 7, 4, 5]
      }, {
        name: '较大任务',
        type: 'bar',
        barWidth: 20,
        barGap: '-100%',
        stack: '工单',
        itemStyle: {
          barBorderRadius: 20,
          color: new echarts.graphic.LinearGradient(0, 0, 0, 1, [{
            offset: 0.4,
            color: "rgba(255,252,0,1)"
          }, {
            offset: 1,
            color: "rgba(8,228,222,0.2)"
          }])
        },
        data: [1, 1, 2, 1, 2, 2, 1]
      }, {
        name: '重大任务',
        type: 'bar',
        barWidth: 20,
        barGap: '-100%',
        stack: '工单',
        itemStyle: {
          barBorderRadius: 20,
          color: new echarts.graphic.LinearGradient(0, 0, 0, 1, [{
            offset: 0.4,
            color: "orange"
          }, {
            offset: 1,
            color: "yellow"
          }])
        },
        data: [1, 2, 1, 2, 1, 1, 1]
      }];
      this.initBarChart(data);
    }
  }
};